"use client";

import { useTranslations } from "use-intl";

import { TracklistSection } from "@/components/music/tracklist-section";
import { Tracklist, type Medium, type TrackVideo } from "@/components/tracklist";
import { useTrackVideoPlayerControls } from "@/hooks/use-track-video-player-controls";
import { useTrackVideoPlaylist } from "@/hooks/use-track-video-playlist";

export function ReleaseTracklist({
  media,
  artistName,
  trackVideos = [],
}: {
  media: Medium[];
  artistName?: string | null;
  trackVideos?: TrackVideo[];
}) {
  const t = useTranslations("release");
  const playlist = useTrackVideoPlaylist(media, trackVideos);
  const { playByYoutubeId: handlePlay } = useTrackVideoPlayerControls({
    playlist,
    artistName: artistName ?? null,
  });

  return (
    <TracklistSection
      title={t("tracklist")}
      hasTracks={media.some((m) => m.tracks.length > 0)}
      emptyLabel={t("noTracks")}
    >
      <Tracklist media={media} onPlay={handlePlay} trackVideos={trackVideos} />
    </TracklistSection>
  );
}
